import axios from 'axios'
import { Firmware, FirmwareDeviceModelOptions, FirmwareImportBody, FirmwareQueryParam, FirmwareUploadUrlBody, FirmwareUploadUrlData } from '/@/types/device-firmware'
import request, { CommonListResponse, IListWorkspaceResponse, IPage, IWorkspaceResponse } from '/@/api/http/request'
import { Device, DeviceOnlineState, DeviceUnbindingContext, DeviceUnbindingPreview } from '/@/types/device'
import { CURRENT_CONFIG } from '/@/api/http/config'

const HTTP_PREFIX = '/manage/api/v1'
const minioUploadRequest = axios.create({
  transformResponse: [(data) => data]
})

// login
export interface LoginBody {
 username: string,
 password: string,
 flag: number,
}
export interface WebLoginBody {
  username: string,
  password: string,
  flag: number,
  verify_code: string,
  verify_key: string,
}
export interface RandomImageResponse {
  base64: string,
}
export interface loginByToken {
  token: string,
}
export interface BindBody {
  device_sn: string,
  user_id: string,
  workspace_id: string,
  domain?: string
}
export interface OrbitWaylineDeliverBody {
  workspace_id: string,
  dock_sn: string,
  target_latitude: number,
  target_longitude: number,
  target_height: number,
  flight_height: number,
  clockwise: boolean,
  radius: number,
  point_count: number,
  circle_count: number,
}
export interface InFlightWaylineControlBody {
  dock_sn: string,
  in_flight_wayline_id: string,
}
export interface InFlightWaylineCurrentTaskQuery {
  workspace_id: string,
  drone_sn: string,
}
export interface HmsQueryBody {
  sns: string[],
  children_sn: string,
  device_sn: string,
  language: string,
  level: number | string,
  begin_time: number,
  end_time: number,
  message: string,
  domain: number,
}
export interface WaylineAircraftModelOption {
  value: string,
  type: number,
  label: string,
  gimbalindex: number,
  payload_lens_index_options?: Array<{ value: string, label: string }>,
  mounted_devices?: any[],
  payloads?: any[],
  sub_type: number,
  payload_type: number,
  payload_sub_type: number,
}
export interface WaylineAircraftSeriesOption {
  value: string,
  label: string,
  children: WaylineAircraftModelOption[],
}

export const exportDroneReportPackage = function (workspaceId:string, jobId:string) {
  return `${CURRENT_CONFIG.baseURL}${HTTP_PREFIX}/report/exportDroneReportPackage/${workspaceId}/${jobId}`
}
export const login = async function (body: LoginBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/login`
  const result = await request.post(url, body)
  return result.data
}
export const webLogin = async function (body: WebLoginBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/vsLogin`
  const result = await request.post(url, body)
  return result.data
}
export const deliverOrbitWayline = async function (body: OrbitWaylineDeliverBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/in-flight-wayline/orbit/deliver`
  const result = await request.post(url, body)
  return result.data
}
export const stopInFlightWayline = async function (body: InFlightWaylineControlBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/in-flight-wayline/stop`
  const result = await request.post(url, body)
  return result.data
}
export const recoverInFlightWayline = async function (body: InFlightWaylineControlBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/in-flight-wayline/recover`
  const result = await request.post(url, body)
  return result.data
}
export const cancelInFlightWayline = async function (body: InFlightWaylineControlBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/in-flight-wayline/cancel`
  const result = await request.post(url, body)
  return result.data
}
export const getCurrentInFlightWaylineTask = async function (query: InFlightWaylineCurrentTaskQuery): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/in-flight-wayline/current-task`
  const result = await request.get(url, {
    params: query,
    skipGlobalErrorMessage: true,
  })
  return result.data
}
export const getWaylineAircraftOptions = async function (): Promise<IWorkspaceResponse<WaylineAircraftSeriesOption[]>> {
  const url = `${HTTP_PREFIX}/business/waylineAircraft/options`
  const result = await request.get(url)
  return result.data
}
export const getInFlightWaylineDetail = async function (inFlightWaylineId: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/in-flight-wayline/detail`
  const result = await request.get(url, {
    params: {
      inFlightWaylineId,
    },
    skipGlobalErrorMessage: true,
  })
  return result.data
}
export const getRandomImage = async function (key: string): Promise<IWorkspaceResponse<RandomImageResponse>> {
  const url = `${HTTP_PREFIX}/randomImage/${key}`
  const result = await request.get(url, {
    skipGlobalErrorMessage: true,
    skipTimeoutRedirect: true,
    errorMessageKey: 'captcha-load'
  } as any)
  return result.data
}
export const loginByToken = async function (body: loginByToken): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/loginByToken`
  const result = await request.post(url, body)
  return result.data
}

// Refresh Token
export const refreshToken = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/token/refresh`
  const result = await request.post(url, body)
  return result.data
}

// Get Platform Info
export const getPlatformInfo = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/current`
  const result = await request.get(url)
  return result.data
}

export const getPlatformName = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/platform/name`
  const result = await request.get(url)
  return result.data
}

// Get User Info
export const getUserInfo = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/current`
  const result = await request.get(url)
  return result.data
}
// 添加用户账号
export const addUser = async function (data:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/addUser`
  const result = await request.post(url, data)
  return result.data
}
// 修改用户账号
export const updateUser = async function (data:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/updateUser`
  const result = await request.post(url, data)
  return result.data
}
// 删除用户账号
export const deleteUserById = async function (userId:number): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/deleteUserById/${userId}`
  const result = await request.get(url)
  return result.data
}
// 获取用户账号列表
export const getUserListPageVo = async function (data:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/getUserListPageVo`
  const result = await request.post(url, data)
  return result.data
}
// Get Device Topo
export const getDeviceTopo = async function (workspace_id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices`
  const result = await request.get(url, { skipTimeoutRedirect: true } as any)
  return result.data
}

// Get All Devices (supports workspace_id = null for all projects)
export const getAllDevices = async function (workspace_id: string | null): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/allDevices`
  const result = await request.get(url)
  return result.data
}

export interface DockMqttQueryParams {
  workspace_id?: string
}

export const getDockMqtt = async function (params?: DockMqttQueryParams): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/getDockMqtt`
  const result = await request.get(url, { params })
  return result.data
}

export const getDroneUrl = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/getDroneUrl`
  const result = await request.get(url)
  return result.data
}

export const getPilot = async function (workspaceId: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/getPilot/${workspaceId}`
  const result = await request.get(url)
  return result.data
}

// Get Livestream Capacity
export const getLiveCapacity = async function (workspaceId:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/capacity/` + workspaceId
  const result = await request.get(url)
  return result.data
}

// Start Livestream
export const startLivestream = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/start`
  const result = await request.post(url, body)
  return result.data
}

// Stop Livestream
export const stopLivestream = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/stop`
  const result = await request.post(url, body)
  return result.data
}
// Update Quality
export const setLivestreamQuality = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/update`
  const result = await request.post(url, body)
  return result.data
}

export const getAllUsersInfo = async function (wid: string, body: IPage): Promise<CommonListResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users?&page=${body.page_num}&page_size=${body.page_size}`
  const result = await request.get(url)
  return result.data
}

export const updateUserInfo = async function (wid: string, user_id: string, body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users/${user_id}`
  const result = await request.put(url, body)
  return result.data
}

export const bindDevice = async function (body: BindBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${body.device_sn}/binding`
  const result = await request.post(url, body, { skipTimeoutRedirect: true } as any)
  return result.data
}

export const getDeviceUnbindingPreview = async function (device_sn: string): Promise<IWorkspaceResponse<DeviceUnbindingPreview>> {
  const result = await request.get(`${HTTP_PREFIX}/devices/${device_sn}/unbinding-preview`, { skipGlobalErrorMessage: true } as any)
  return result.data
}

export const unbindDevice = async function (device_sn: string, context?: DeviceUnbindingContext): Promise<IWorkspaceResponse<{ cache_synced?: boolean }>> {
  const url = `${HTTP_PREFIX}/devices/${device_sn}/unbinding`
  const result = await request.delete(url, { params: context, skipGlobalErrorMessage: true } as any)
  return result.data
}

export const getDeviceBySn = async function (workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/${device_sn}`
  const result = await request.get(url)
  return result.data
}

// query device detail by ID
export const queryDeviceById = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/business/vendorxDevice/queryById`
  const result = await request.get(url, { params: { id } })
  return result.data
}

// 固定翼设备新增
export interface FixedWingDeviceAddBody {
  workspace_id: string
  device_status: string
  device_sn: string
  device_name: string
  device_type?: string
  login_time?: string
  telemetry_config?: string
  streaming_config?: string
  drone_image?: string
  remark?: string
  attachments?: string
}

export const addFixedWingDevice = async function (body: FixedWingDeviceAddBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/business/vendorxDevice/add`
  const result = await request.post(url, body)
  return result.data
}

export interface FixedWingDeviceEditBody extends FixedWingDeviceAddBody {
  id: string | number
}

export const editFixedWingDevice = async function (body: FixedWingDeviceEditBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/business/vendorxDevice/edit`
  const result = await request.put(url, body)
  return result.data
}

// 固定翼设备批量删除
export const deleteFixedWingBatch = async function (ids: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/business/vendorxDevice/deleteBatch`
  const result = await request.delete(url, { params: { ids } })
  return result.data
}

// 固定翼设备列表查询参数
export interface FixedWingDeviceQueryParams {
  page_no: number
  page_size: number
  workspace_id?: string
  device_status?: string
  device_sn?: string
  device_name?: string
}

// 获取固定翼设备列表
export const getFixedWingDeviceList = async function (body: FixedWingDeviceQueryParams): Promise<CommonListResponse<any>> {
  const url = `${HTTP_PREFIX}/business/vendorxDevice/list`
  const result = await request.get(url, { params: body })
  return result.data
}

// 推流设备
export interface StreamDeviceBody {
  id?: string | number
  device_sn: string
  device_model?: string
  device_name: string
  device_status?: string
  last_online_time?: string
  stream_url?: string
  region_code: string
  workspace_id: string
  device_image?: string
  device_type?: string
  location?: string
  longitude?: string
  latitude?: string
  altitude?: number | string
  remark?: string
}

export interface StreamDeviceQueryParams {
  page_no?: number
  page?: number
  page_size: number
  region_code?: string
  workspace_id?: string
  device_status?: string
  device_sn?: string
  device_name?: string
  device_type?: string
}

export const getStreamDeviceList = async function (params: StreamDeviceQueryParams): Promise<CommonListResponse<any>> {
  const url = `${HTTP_PREFIX}/business/streamDevice/list`
  const result = await request.get(url, { params })
  return result.data
}

export const addStreamDevice = async function (body: StreamDeviceBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/business/streamDevice/add`
  const result = await request.post(url, body)
  return result.data
}

export const editStreamDevice = async function (body: StreamDeviceBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/business/streamDevice/edit`
  const result = await request.put(url, body)
  return result.data
}

export const queryStreamDeviceById = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/business/streamDevice/queryById`
  const result = await request.get(url, { params: { id } })
  return result.data
}

export const deleteStreamDeviceBatch = async function (ids: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/business/streamDevice/deleteBatch`
  const result = await request.delete(url, { params: { ids } })
  return result.data
}

/**
 * 获取绑定设备信息
 * @param workspace_id
 * @param body
 * @param domain
 * @returns
 */
export const getBindingDevices = async function (workspace_id: string, body: IPage, domain: number): Promise<IListWorkspaceResponse<Device>> {
  const currentPage = body.page_num || (body as IPage & { page?: number }).page || 1
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/bound?&page=${currentPage}&page_size=${body.page_size}&domain=${domain}`
  const result = await request.get(url)
  return result.data
}

export const updateDevice = async function (body: {}, workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/${device_sn}`
  const result = await request.put(url, body)
  return result.data
}

export const getUnreadDeviceHms = async function (workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms/${device_sn}`
  const result = await request.get(url)
  return result.data
}

export const updateDeviceHms = async function (workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms/${device_sn}`
  const result = await request.put(url)
  return result.data
}

export const getDeviceHms = async function (body: HmsQueryBody, workspace_id: string, pagination: IPage): Promise<IListWorkspaceResponse<any>> {
  let url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms?page=${pagination.page_num}&page_size=${pagination.page_size}` +
    `&level=${body.level ?? ''}&begin_time=${body.begin_time ?? ''}&end_time=${body.end_time ?? ''}&message=${body.message ?? ''}&language=${body.language}`
  body.sns.forEach((sn: string) => {
    if (sn !== '') {
      url = url.concat(`&device_sn=${sn}`)
    }
  })
  const result = await request.get(url)
  return result.data
}

export const changeLivestreamLens = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/switch`
  const result = await request.post(url, body)
  return result.data
}

export const getFirmwares = async function (workspace_id: string, page: IPage, body: FirmwareQueryParam): Promise<IListWorkspaceResponse<Firmware>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspace_id}/firmwares?page=${page.page_num}&page_size=${page.page_size}` +
    `&device_name=${encodeURIComponent(body.device_name)}&product_version=${encodeURIComponent(body.product_version)}&status=${body.firmware_status ?? ''}`
  const result = await request.get(url)
  return result.data
}

export const getFirmwareDeviceModels = async function (workspaceId: string): Promise<IWorkspaceResponse<FirmwareDeviceModelOptions>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/device-models`
  const result = await request.get(url, { skipGlobalErrorMessage: true } as any)
  return result.data
}

export const importFirmareFile = async function (workspaceId: string, param: FormData): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/file/upload`
  const result = await request.post(url, param)
  return result.data
}

export const getFirmwareUploadUrl = async function (workspaceId: string, body: FirmwareUploadUrlBody): Promise<IWorkspaceResponse<FirmwareUploadUrlData>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/file/upload-url`
  const result = await request.post(url, body, { skipGlobalErrorMessage: true } as any)
  return result.data
}

export const uploadFirmwareToMinio = async function (
  uploadUrl: string,
  file: File,
  onUploadProgress?: (progressEvent: any) => void
) {
  return await minioUploadRequest.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type || 'application/zip'
    },
    onUploadProgress
  })
}

export const importFirmwareMetadata = async function (workspaceId: string, body: FirmwareImportBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/file/import`
  const result = await request.post(url, body, { skipGlobalErrorMessage: true } as any)
  return result.data
}

export const changeFirmareStatus = async function (workspaceId: string, firmwareId: string, param: {status: boolean}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/${firmwareId}`
  const result = await request.put(url, param)
  return result.data
}
// 喊话器音量设置
export const volumeSet = async function (dockSn: string, param: {psdk_index: number, play_volume:number}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/volumeSet`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器tts喊话
export const ttsPlayStart = async function (dockSn: string, param: {
  psdk_index: number,
  tts: {
    name: string,
    text: string,
    md5: string
  }
}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/ttsPlayStart`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器停止播放
export const stopPlay = async function (dockSn: string, param: {psdk_index: number}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/stopPlay`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器重复播放
export const replay = async function (dockSn: string, param: {psdk_index: number}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/replay`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器播放模式playMode,0,1
export const playModeSet = async function (dockSn: string, param: {psdk_index: number, play_mode:number}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/playModeSet`
  const result = await request.post(url, param)
  return result.data
}
// speaker input box playback
export const inputBoxTextSet = async function (dockSn: string, param: {psdk_index: number, value:string}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/inputBoxTextSet`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器录音播放
export const audioPlayStart = async function (dockSn: string, param: {psdk_index: number, file: {
  name: string,
  url: string,
  md5: string,
  format: string// 默认pcm
}}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/audioPlayStart`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器上传pcm文件
export const importPcmFile = async function (formData: FormData): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/pcmFile/upload`
  const result = await request.post(url, formData)
  return result.data
}
export const getPcmHistory = async function (workspace_id:string, page:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${workspace_id}/getPcmHistory`
  const result = await request.post(url, page)
  return result.data
}
// 喊话列表
export const getAudioFileList = async function (workspace_id:string, page:any): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/${workspace_id}/files?page=${page.page || page.page_num}&page_size=${page.page_size}`
  const result = await request.get(url)
  return result.data
}
// 喊话列表删除
export const deleteAudioFileList = async function (audio_id:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/deleteById/${audio_id}`
  const result = await request.get(url)
  return result.data
}
// tts文本列表
export const getPsdkTextList = async function (workspace_id:string, page: { page?: number; page_num?: number; page_size?: number }): Promise<IWorkspaceResponse<any>> {
  const pageNum = page.page || page.page_num || 1
  const pageSize = page.page_size || 10
  const url = `${HTTP_PREFIX}/speaker/${workspace_id}/getPsdkTextList?page=${pageNum}&page_size=${pageSize}`
  const result = await request.get(url)
  return result.data
}
export const saveTtsContent = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/saveTtsContent`
  const result = await request.post(url, body)
  return result.data
}
export const getTtsContentListPage = async function (body:object, workspaceId:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/getTtsContentListPage/${workspaceId}`
  const result = await request.post(url, body)
  return result.data
}
export const deleteTtsContent = async function (id:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/deleteTtsContent/${id}`
  const result = await request.post(url)
  return result.data
}
// 灯�
export const widgetValueSet = async function (dockSn: string, param:{
  psdk_index: number,
  index:number,
  value:number
}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/widgetValueSet`
  const result = await request.post(url, param)
  return result.data
}
// 获取指点飞行文件列表
export const getFlightIdList = async function (workspace_id:string, page:IPage): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/takeToPoint/${workspace_id}/getFlightIdList`
  const result = await request.get(url, {
    params: {
      page: page.page_num,
      page_size: page.page_size,
      sn: page.sn ?? "",
      start_time: page.start_time || undefined,
      end_time: page.end_time || undefined
    }
  })
  return result.data
}

export const deleteTakeToPointFlights = async function (workspaceId: string, flightIds: string[]): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/takeToPoint/${workspaceId}/flights`
  const result = await request.delete(url, { data: { flight_ids: flightIds } })
  return result.data
}
// 获取首页信息
export const getIndexData = async function (workspaceId?: string): Promise<IWorkspaceResponse<any>> {
  let url = '/app/api/v1/business/screen/getIndexData'
  if (workspaceId) {
    url = `${url}?workspace_id=${workspaceId}`
  }
  const result = await request.get(url)
  return result.data
}
// 获取告警信息列表
export const getAlarmDataListPageVo = async function (param:{
  page_num:number,
  page_size:number,
  region_code?:number,
  workspace_id:string,
  start_time?: number | string | null
}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/alarmData/getAlarmDataListPageVo`
  const result = await request.post(url, param, { skipTimeoutRedirect: true } as any)
  return result.data
}
// 获取算法模型列表（分页）
export const getAlgorithmModelListPageVo = async function (param:{
  page_num:number,
  page_size:number,
  algorithm_type:any,
  search_key:any,
  workspace_id:string
}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/getAlgorithmModelListPageVo`
  const result = await request.post(url, param)
  return result.data
}
// 获取云端算法模型下拉列表（xhq 专用）
export const getAlgorithmModelList = async function (param:any): Promise<IWorkspaceResponse<any>> {
  const url = 'xhq/ai/getAlgorithmModelList'
  // 该接口为 GET，请求参数通过 query 传递
  const result = await request.get(url, { params: param })
  return result.data
}
// 选择算法-获取拉流地址
export const manuallyConfigureAi = async function (body: {
  workspaceId: string
  dockSn: string
  droneSn: string
  djlBool: boolean
  modelNo: string
  taskStatus: string
}): Promise<IWorkspaceResponse<any>> {
  const url = 'xhq/ai/manuallyConfigureAi'
  const result = await request.post(url, body)
  return result.data
}
// 编辑算法模型详�

export const setAlgorithmModelDetail = async function (body: {
  id: number | string
  name?: string
  algorithmBusinessType?: string
  about?: string
  img_url?: string
}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/setAlgorithmModelDetail`
  const result = await request.post(url, body)
  return result.data
}

// 删除算法模型
export const deleteAlgorithmModelById = async function (body: {
  id: number | string
}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/deleteAlgorithmModelById`
  const result = await request.post(url, body)
  return result.data
}
// 获取算法类型
export const getAiTypeDataDict = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/getAiTypeDataDict`
  const result = await request.get(url)
  return result.data
}
export const getAlarmId = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/alarmData/getAlarmId`
  const result = await request.post(url, body)
  return result.data
}
export const toCheckPoint = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/alarmData/toCheckPoint`
  const result = await request.post(url, body)
  return result.data
}
export const personFaceLibPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/personFaceLibPage`
  const result = await request.post(url, body)
  return result.data
}
export const personFaceLibAdd = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/personFaceLibAdd`
  const result = await request.post(url, body)
  return result.data
}
export const personFaceLibUpdate = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/personFaceLibUpdate`
  const result = await request.post(url, body)
  return result.data
}
export const plateLibUpdate = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/plateLibUpdate`
  const result = await request.post(url, body)
  return result.data
}
export const personFaceLibBatchDelete = async function (data:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/personFaceLibBatchDelete`
  const result = await request.post(url, data)
  return result.data
}
export const plateLibPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/plateLibPage`
  const result = await request.post(url, body)
  return result.data
}
export const plateLibAdd = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/plateLibAdd`
  const result = await request.post(url, body)
  return result.data
}
export const plateLibBatchDelete = async function (data:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/plateLibBatchDelete`
  const result = await request.post(url, data)
  return result.data
}
export const faceCompareRecordPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/faceCompareRecordPage`
  const result = await request.post(url, body)
  return result.data
}
export const carCompareRecordPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/carCompareRecordPage`
  const result = await request.post(url, body)
  return result.data
}
export const cameraPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/cameraPage`
  const result = await request.post(url, body)
  return result.data
}
export const addCamera = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/addCamera`
  const result = await request.post(url, body)
  return result.data
}
export const deleteCamera = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/deleteCamera`
  const result = await request.post(url, body)
  return result.data
}
export const updateCamera = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/updateCamera`
  const result = await request.post(url, body)
  return result.data
}

// 通用上传图片/文件，返回完整 URL（用于固定翼图片/附件等）
export const fullPathUploadImage = async function (file: File): Promise<IWorkspaceResponse<string>> {
  const url = `${HTTP_PREFIX}/baseInfo/fullPathUploadImage`
  const formData = new FormData()
  formData.append('file', file)
  const result = await request.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
export const uploadFace = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = '/upload_face'
  const result = await request.post(url, body, {
    baseURL: '/infer/'
  })
  return result.data
}
export const deleteFace = async function (body: object): Promise<IWorkspaceResponse<any>> {
  const url = '/delete_face'
  const formData = new FormData()
  formData.append('json', JSON.stringify(body))

  const result = await request.post(url, formData, {
    baseURL: '/infer/',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
export const deletePlate = async function (body: object): Promise<IWorkspaceResponse<any>> {
  const url = '/delete_plate'
  const formData = new FormData()
  formData.append('json', JSON.stringify(body))

  const result = await request.post(url, formData, {
    baseURL: '/infer/',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
export const uploadPlate = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = '/upload_plate'
  const result = await request.post(url, body, {
    baseURL: '/infer/'
  })
  return result.data
}
export const getPerson = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/get_person'
  const result = await request.get(url, {
    baseURL: '/infer/'
  })
  return result.data
}
export const ctrlDrone = async function (query: object): Promise<IWorkspaceResponse<any>> {
  const url = '/ctrl_drone'
  const formData = new FormData()
  // 注意这里要转成字符串
  formData.append('json', JSON.stringify(query))
  const result = await request.post(url, formData, {
    baseURL: '/infer/',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
export const getPlate = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/get_plate'
  const result = await request.get(url, {
    baseURL: '/infer/'
  })
  return result.data
}
export const getSnap = async function (query: object): Promise<IWorkspaceResponse<any>> {
  const url = '/get_snap'
  const formData = new FormData()
  // 注意这里要转成字符串
  formData.append('json', JSON.stringify(query))
  const result = await request.post(url, formData, {
    baseURL: '/infer/',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
// 新绑定算法
export const bindingAiAlgorithm = async function (body:{}): Promise<IWorkspaceResponse<{}>> {
  const url = `${HTTP_PREFIX}/ai/bindingAiAlgorithm`
  const result = await request.post(url, body)
  return result.data
}
// 获取新绑定算法
export const getWayLineAiBindingDetail = async function (body:{}): Promise<IWorkspaceResponse<{}>> {
  const url = `${HTTP_PREFIX}/ai/getWayLineAiBindingDetail`
  const result = await request.post(url, body)
  return result.data
}
// 获取推送日志列表
export const getHttpPushLogListPageVo = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/httpPushLog/getHttpPushLogListPageVo`
  const result = await request.post(url, body)
  return result.data
}
// 通过选择的两个飞行任务id对比相同图片的差异
export const diffImageByJobIds = async function (data: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/diffImageByJobIds`
  const result = await request.post(url, data)
  return result.data
}
// 通过航线id查询飞行任务媒体数一致的数据
export const getFlyJobMediaCountSameByWayLineId = async function (wayLineId:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/getFlyJobMediaCountSameByWayLineId?wayLineId=${wayLineId}`
  const result = await request.get(url)
  return result.data
}
// 查询对比过的数据
export const getDiffImageListPageVo = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/getDiffImageListPageVo`
  const result = await request.post(url, body)
  return result.data
}
// 删除图片对比数据
export const deleteDiffImageById = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/deleteDiffImageById`
  const result = await request.post(url, body)
  return result.data
}
// 航线绑定文件对比，是否开启
export const addWayLineFileDiffData = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/wayLineFileDiffData/addWayLineFileDiffData`
  const result = await request.post(url, body)
  return result.data
}

// 获取航线绑定文件对比详�

export const getWayLineFileDiffDataById = async function (wayLineId:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/wayLineFileDiffData/getWayLineFileDiffDataByWayLineId/${wayLineId}`
  const result = await request.get(url)
  return result.data
}
// 删除航线绑定对比信息
export const deleteWayLineFileDiffDataById = async function (id:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/wayLineFileDiffData/deleteWayLineFileDiffDataById/${id}`
  const result = await request.get(url)
  return result.data
}
// 批量删除告警
export const batchDeleteAlarmById = async function (ids: string[]): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/alarmData/batchDeleteAlarmById`
  const result = await request.post(url, { ids })
  return result.data
}
// 标记错误告警 --新接口
export const setAlarmStatus = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/manage/api/v1/alarmData/setAlarmStatus'
  const result = await request.post(url, body)
  return result.data
}
// 设置告警描述
export const setAlarmDesc = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/manage/api/v1/alarmData/setAlarmDesc'
  const result = await request.post(url, body)
  return result.data
}
// 获取当前用户的工作空间树形数据
export const getWorkspaceByCurrentUser = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/app/api/v1/business/common/getWorkspaceByCurrentUser'
  const result = await request.get(url)
  return result.data
}

// 3D地图连接�
export const addThreeDMapConfig = async (data: any) => {
  const result = await request.post(`${HTTP_PREFIX}/business/threeDMapConfig/add`, data)
  return result.data
}

export const editThreeDMapConfig = async (data: any) => {
  const result = await request.put(`${HTTP_PREFIX}/business/threeDMapConfig/edit`, data)
  return result.data
}

export const queryThreeDMapConfigById = async (id: string) => {
  const result = await request.get(`${HTTP_PREFIX}/business/threeDMapConfig/queryById`, { params: { id } })
  return result.data
}

export const listThreeDMapConfig = async (params: any) => {
  const result = await request.get(`${HTTP_PREFIX}/business/threeDMapConfig/list`, { params: { ...params, page_no: params.pageNo, page_size: params.pageSize } })
  return result.data
}

export const deleteThreeDMapConfig = async (id: string) => {
  const result = await request.delete(`${HTTP_PREFIX}/business/threeDMapConfig/delete`, { params: { id } })
  return result.data
}

// Read current-page state without loading detail, firmware or the entire list.
export const getDeviceOnlineStates = async function (workspaceId: string, sns: string[]): Promise<IWorkspaceResponse<DeviceOnlineState[]>> {
  const result = await request.get(`${HTTP_PREFIX}/devices/${encodeURIComponent(workspaceId)}/devices/online-state`, {
    params: { device_sns: sns.join(',') },
    timeout: 15000,
    skipGlobalErrorMessage: true,
  } as any)
  return result.data
}

// Read-only last confirmed aircraft detail; server verifies organization and dock pairing.
export async function getAircraftDetail (deviceSn: string, dockSn?: string): Promise<IWorkspaceResponse<any>> {
  const res = await request.get(`${HTTP_PREFIX}/devices/${encodeURIComponent(deviceSn)}/aircraft-detail`, { params: dockSn ? { dock_sn: dockSn } : {} })
  return res.data
}
